export default "__VITE_ASSET__BRVHdeiv__"